var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page flex-col"},[_c('img',{staticClass:"image_4",attrs:{"referrerpolicy":"no-referrer","src":require("./assets/img/SketchPng47190e2cd27354a017a64ae9598b7ae32351c46eb2bd55f92244025eb58fc14c.png")}})])
}]

export { render, staticRenderFns }